export const translations = {
  'pt-BR': {
    nav: {
      about: 'Sobre',
      experience: 'Experiência',
      skills: 'Habilidades',
      contact: 'Contato'
    },
    hero: {
      greeting: 'Olá, eu sou',
      name: 'João Paulo Belatto',
      title: 'Engenheiro de Software | Desenvolvedor Java Senior',
      subtitle: '15+ anos de experiência em aplicações Java de alta disponibilidade para os setores de telecomunicações, finanças e seguros',
      location: 'Pinerolo, Itália',
      cta: 'Ver Experiência',
      contact: 'Entrar em Contato',
      downloadCv: 'Baixar CV'
    },
    about: {
      title: 'Sobre Mim',
      description: 'Engenheiro de Software orientado a resultados com mais de 15 anos de experiência projetando e entregando aplicações Java de alta disponibilidade para os setores de telecomunicações, finanças e seguros. Histórico comprovado de modernização de sistemas batch legados e liderança de integrações de microsserviços em ambientes Ágeis (SAFe/Scrum). Apaixonado por código limpo, otimização de performance e tradução de requisitos de negócio complexos em soluções de software escaláveis.',
      focus: 'Especialidades',
      focusText: 'Telecomunicações • Finanças • Seguros • Microsserviços • Spring Boot • Processamento Batch'
    },
    experience: {
      title: 'Experiência Profissional',
      projects: 'Projetos',
      challenges: 'Desafios Superados',
      lessons: 'Lições Aprendidas',
      present: 'Presente'
    },
    skills: {
      title: 'Tecnologias & Habilidades',
      languages: 'Linguagens',
      databases: 'Bancos de Dados',
      frameworks: 'Frameworks & Ferramentas',
      devops: 'DevOps & Ferramentas'
    },
    contact: {
      title: 'Vamos Conversar',
      subtitle: 'Pronto para o próximo desafio',
      description: 'Interessado em discutir oportunidades ou projetos? Entre em contato comigo.',
      email: 'Enviar Email',
      linkedin: 'LinkedIn',
      sendMessage: 'Envie uma Mensagem',
      contactInfo: 'Informações de Contato',
      professionalLinks: 'Links Profissionais',
      location: 'Localização',
      phone: 'Telefone',
      namePlaceholder: 'Seu nome completo',
      emailPlaceholder: 'seu.email@empresa.com',
      companyPlaceholder: 'Nome da sua empresa',
      messagePlaceholder: 'Descreva o projeto ou oportunidade...',
      nameLabel: 'Nome',
      emailLabel: 'Email',
      companyLabel: 'Empresa',
      messageLabel: 'Mensagem',
      sending: 'Enviando...',
      send: 'Enviar Mensagem',
      successTitle: 'Mensagem enviada com sucesso!',
      successText: 'Entrarei em contato em breve.',
      errorTitle: 'Erro ao enviar mensagem',
      errorText: 'Tente novamente ou envie direto para: contact@belatto.it'
    }
  },
  'en': {
    nav: {
      about: 'About',
      experience: 'Experience',
      skills: 'Skills',
      contact: 'Contact'
    },
    hero: {
      greeting: 'Hello, I am',
      name: 'João Paulo Belatto',
      title: 'Software Engineer | Senior Java Developer',
      subtitle: '15+ years of experience in high-availability Java applications for telecom, finance, and insurance sectors',
      location: 'Pinerolo, Italy',
      cta: 'View Experience',
      contact: 'Get In Touch',
      downloadCv: 'Download CV'
    },
    about: {
      title: 'About Me',
      description: 'Results-oriented Software Engineer with 15+ years of experience architecting and delivering high-availability Java applications for the telecom, finance, and insurance sectors. Proven track record of modernizing legacy batch systems and leading microservices integrations in Agile environments (SAFe/Scrum). Passionate about clean code, performance optimization, and translating complex business requirements into scalable software solutions.',
      focus: 'Specialties',
      focusText: 'Telecom • Finance • Insurance • Microservices • Spring Boot • Batch Processing'
    },
    experience: {
      title: 'Professional Experience',
      projects: 'Projects',
      challenges: 'Challenges Overcome',
      lessons: 'Lessons Learned',
      present: 'Present'
    },
    skills: {
      title: 'Technologies & Skills',
      languages: 'Languages',
      databases: 'Databases',
      frameworks: 'Frameworks & Tools',
      devops: 'DevOps & Tools'
    },
    contact: {
      title: 'Let\'s Talk',
      subtitle: 'Ready for the next challenge',
      description: 'Interested in discussing opportunities or projects? Get in touch with me.',
      email: 'Send Email',
      linkedin: 'LinkedIn',
      sendMessage: 'Send a Message',
      contactInfo: 'Contact Information',
      professionalLinks: 'Professional Links',
      location: 'Location',
      phone: 'Phone',
      namePlaceholder: 'Your full name',
      emailPlaceholder: 'your.email@company.com',
      companyPlaceholder: 'Your company name',
      messagePlaceholder: 'Describe the project or opportunity...',
      nameLabel: 'Name',
      emailLabel: 'Email',
      companyLabel: 'Company',
      messageLabel: 'Message',
      sending: 'Sending...',
      send: 'Send Message',
      successTitle: 'Message sent successfully!',
      successText: 'I will get back to you soon.',
      errorTitle: 'Error sending message',
      errorText: 'Try again or send directly to: contact@belatto.it'
    }
  },
  'it': {
    nav: {
      about: 'Chi Sono',
      experience: 'Esperienza',
      skills: 'Competenze',
      contact: 'Contatti'
    },
    hero: {
      greeting: 'Ciao, sono',
      name: 'João Paulo Belatto',
      title: 'Ingegnere Software | Sviluppatore Java Senior',
      subtitle: '15+ anni di esperienza in applicazioni Java ad alta disponibilità per i settori telecomunicazioni, finanza e assicurazioni',
      location: 'Pinerolo, Italia',
      cta: 'Vedi Esperienza',
      contact: 'Contattami',
      downloadCv: 'Scarica CV'
    },
    about: {
      title: 'Chi Sono',
      description: 'Ingegnere Software orientato ai risultati con oltre 15 anni di esperienza nella progettazione e consegna di applicazioni Java ad alta disponibilità per i settori telecomunicazioni, finanza e assicurazioni. Comprovata capacità di modernizzazione di sistemi batch legacy e guida di integrazioni microservizi in ambienti Agile (SAFe/Scrum). Appassionato di codice pulito, ottimizzazione delle prestazioni e traduzione di requisiti aziendali complessi in soluzioni software scalabili.',
      focus: 'Specialità',
      focusText: 'Telecomunicazioni • Finanza • Assicurazioni • Microservizi • Spring Boot • Elaborazione Batch'
    },
    experience: {
      title: 'Esperienza Professionale',
      projects: 'Progetti',
      challenges: 'Sfide Superate',
      lessons: 'Lezioni Apprese',
      present: 'Presente'
    },
    skills: {
      title: 'Tecnologie & Competenze',
      languages: 'Linguaggi',
      databases: 'Database',
      frameworks: 'Framework & Strumenti',
      devops: 'DevOps & Strumenti'
    },
    contact: {
      title: 'Parliamo',
      subtitle: 'Pronto per la prossima sfida',
      description: 'Interessato a discutere opportunità o progetti? Contattami.',
      email: 'Invia Email',
      linkedin: 'LinkedIn',
      sendMessage: 'Invia un Messaggio',
      contactInfo: 'Informazioni di Contatto',
      professionalLinks: 'Link Professionali',
      location: 'Posizione',
      phone: 'Telefono',
      namePlaceholder: 'Il tuo nome completo',
      emailPlaceholder: 'tua.email@azienda.com',
      companyPlaceholder: 'Nome della tua azienda',
      messagePlaceholder: 'Descrivi il progetto o l\'opportunità...',
      nameLabel: 'Nome',
      emailLabel: 'Email',
      companyLabel: 'Azienda',
      messageLabel: 'Messaggio',
      sending: 'Invio in corso...',
      send: 'Invia Messaggio',
      successTitle: 'Messaggio inviato con successo!',
      successText: 'Ti ricontatterò presto.',
      errorTitle: 'Errore nell\'invio del messaggio',
      errorText: 'Riprova o invia direttamente a: contact@belatto.it'
    }
  }
};

export const experiences = [
  {
    id: 1,
    company: 'Commit SRL',
    logo: '/logos/commit.png',
    role: {
      'pt-BR': 'Analista de Sistemas / Desenvolvedor Java',
      'en': 'Systems Analyst / Java Developer',
      'it': 'Analista di Sistemi / Sviluppatore Java'
    },
    period: { 'pt-BR': '3+ anos', 'en': '3+ years', 'it': '3+ anni' },
    location: 'Turim, Itália',
    hasSubProjects: true,
    subProjects: [
      {
        id: 'commit-elderly',
        client: {
          'pt-BR': 'Ecossistema de Cuidados para Idosos',
          'en': 'Elderly Care Ecosystem',
          'it': 'Ecosistema di Assistenza Anziani'
        },
        description: {
          'pt-BR': 'Arquitetou uma infraestrutura baseada em microsserviços para um ecossistema de cuidados para idosos, integrando módulos de e-commerce, serviços de IA e assistência domiciliar, resultando em 30% de redução no tempo de resposta do sistema.',
          'en': 'Engineered a microservices-based architecture for an elderly care ecosystem, integrating e-commerce, AI services, and home assistance modules, resulting in a 30% reduction in system response time.',
          'it': 'Progettato un\'architettura basata su microservizi per un ecosistema di assistenza agli anziani, integrando moduli di e-commerce, servizi IA e assistenza domiciliare, con una riduzione del 30% nel tempo di risposta del sistema.'
        },
        technologies: ['Java 17/21', 'Spring Boot', 'Spring Data', 'Docker', 'Angular', 'RabbitMQ', 'MS SQL Server']
      },
      {
        id: 'commit-insurance',
        client: {
          'pt-BR': 'Migração de Batch para Seguros',
          'en': 'Insurance Batch Migration',
          'it': 'Migrazione Batch Assicurativo'
        },
        description: {
          'pt-BR': 'Liderou a migração de sistemas de processamento batch legados para Spring Boot, melhorando a eficiência de processamento de dados para um grande cliente de seguros.',
          'en': 'Led the migration of legacy batch processing systems to Spring Boot, improving data processing efficiency for a major insurance client.',
          'it': 'Ha guidato la migrazione di sistemi di elaborazione batch legacy a Spring Boot, migliorando l\'efficienza di elaborazione dati per un importante cliente assicurativo.'
        },
        technologies: ['Java 17', 'Spring Boot', 'Spring Batch', 'Oracle Database', 'Maven', 'Jenkins']
      },
      {
        id: 'commit-financial',
        client: {
          'pt-BR': 'Software de Performance Financeira',
          'en': 'Financial Performance Software',
          'it': 'Software di Performance Finanziaria'
        },
        description: {
          'pt-BR': 'Colaborou em ambiente Ágil SAFe com mais de 35 equipes multifuncionais para entregar software de performance financeira, garantindo alta qualidade de código através de testes com jUnit e Mockito.',
          'en': 'Collaborated in a SAFe Agile environment with over 35 cross-functional teams to deliver financial performance software, ensuring high code quality through jUnit and Mockito testing.',
          'it': 'Ha collaborato in un ambiente Agile SAFe con oltre 35 team cross-funzionali per fornire software di performance finanziaria, garantendo alta qualità del codice attraverso test jUnit e Mockito.'
        },
        technologies: ['Java 11/17', 'Spring Boot', 'Spring Security', 'JPA/Hibernate', 'jUnit', 'Mockito', 'Git']
      }
    ],
    description: {
      'pt-BR': 'Desenvolvimento e manutenção de sistemas enterprise para clientes dos setores de saúde, seguros e finanças, usando arquitetura de microsserviços e metodologias ágeis SAFe.',
      'en': 'Development and maintenance of enterprise systems for healthcare, insurance, and finance sector clients, using microservices architecture and SAFe agile methodologies.',
      'it': 'Sviluppo e manutenzione di sistemi enterprise per clienti dei settori sanitario, assicurativo e finanziario, utilizzando architettura microservizi e metodologie agili SAFe.'
    },
    challenges: {
      'pt-BR': 'Migração de sistemas legados, integração de microsserviços complexos, trabalho em equipes distribuídas com mais de 35 times em ambiente SAFe.',
      'en': 'Legacy system migration, complex microservices integration, working in distributed teams with over 35 teams in a SAFe environment.',
      'it': 'Migrazione di sistemi legacy, integrazione complessa di microservizi, lavoro in team distribuiti con oltre 35 team in ambiente SAFe.'
    },
    lessons: {
      'pt-BR': 'Arquitetura de microsserviços, Spring Boot avançado, SAFe Agile, integração de IA, processamento batch moderno.',
      'en': 'Microservices architecture, advanced Spring Boot, SAFe Agile, AI integration, modern batch processing.',
      'it': 'Architettura microservizi, Spring Boot avanzato, SAFe Agile, integrazione IA, elaborazione batch moderna.'
    },
    technologies: ['Java 11/17/21', 'Spring Boot', 'Spring Batch', 'Spring Security', 'Spring Data', 'Docker', 'Angular', 'RabbitMQ', 'Oracle', 'MS SQL Server', 'Maven', 'Git', 'jUnit', 'Mockito'],
    clients: [
      { name: 'Wolters Kluwer', logo: '/logos/wolterskluwer.png' },
      { name: 'Teleconsys', logo: '/logos/teleconsys.png' },
      { name: 'Unipol', logo: '/logos/unipol.png' }
    ]
  },
  {
    id: 2,
    company: 'Ipse Docet Srl',
    logo: '/logos/ipsedocet.png',
    role: {
      'pt-BR': 'Analista de Sistemas / Desenvolvedor Java',
      'en': 'Systems Analyst / Java Developer',
      'it': 'Analista di Sistemi / Sviluppatore Java'
    },
    period: { 'pt-BR': '4 anos', 'en': '4 years', 'it': '4 anni' },
    location: {
      'pt-BR': 'Turim / Bolonha, Itália',
      'en': 'Turin / Bologna, Italy',
      'it': 'Torino / Bologna, Italia'
    },
    description: {
      'pt-BR': 'Desenvolveu e manteve aplicações web para clientes da Administração Pública (Umbria, Emilia-Romagna), garantindo 99,9% de uptime para serviços críticos ao cidadão. Redesenhou aplicações JSF legadas, implementando uma arquitetura mais modular que reduziu a dívida técnica e simplificou a integração de futuras funcionalidades.',
      'en': 'Developed and maintained web applications for Public Administration clients (Umbria, Emilia-Romagna), ensuring 99.9% uptime for critical citizen services. Redesigned legacy JSF applications, implementing a more modular architecture that reduced technical debt and simplified future feature integration.',
      'it': 'Sviluppato e mantenuto applicazioni web per clienti della Pubblica Amministrazione (Umbria, Emilia-Romagna), garantendo il 99,9% di uptime per servizi critici ai cittadini. Ridisegnato applicazioni JSF legacy, implementando un\'architettura più modulare che ha ridotto il debito tecnico e semplificato l\'integrazione di funzionalità future.'
    },
    challenges: {
      'pt-BR': 'Manutenção de sistemas críticos com 99,9% de uptime, modernização de aplicações JSF legadas, conformidade com regulamentações da administração pública.',
      'en': 'Maintaining critical systems with 99.9% uptime, modernizing legacy JSF applications, compliance with public administration regulations.',
      'it': 'Manutenzione di sistemi critici con 99,9% di uptime, modernizzazione applicazioni JSF legacy, conformità con normative della pubblica amministrazione.'
    },
    lessons: {
      'pt-BR': 'Sistemas governamentais de alta disponibilidade, redesenho de arquitetura modular, JSF avançado, gestão de dívida técnica.',
      'en': 'High-availability government systems, modular architecture redesign, advanced JSF, technical debt management.',
      'it': 'Sistemi governativi ad alta disponibilità, redesign architettura modulare, JSF avanzato, gestione del debito tecnico.'
    },
    technologies: ['Java 8/11', 'JSF', 'PrimeFaces', 'EJB', 'JPA/Hibernate', 'PostgreSQL', 'JBoss', 'Maven', 'Git'],
    clients: [
      { name: 'Regione Umbria', logo: null },
      { name: 'Regione Emilia-Romagna', logo: null }
    ]
  },
  {
    id: 3,
    company: 'Stefanini',
    logo: '/logos/stefanini.png',
    role: {
      'pt-BR': 'Desenvolvedor Java Senior',
      'en': 'Senior Java Developer',
      'it': 'Sviluppatore Java Senior'
    },
    period: { 'pt-BR': '9 meses', 'en': '9 months', 'it': '9 mesi' },
    location: 'São Paulo, Brasil',
    project: {
      'pt-BR': 'Cielo - Processamento de Cartões de Crédito',
      'en': 'Cielo - Credit Card Processing',
      'it': 'Cielo - Elaborazione Carte di Credito'
    },
    description: {
      'pt-BR': 'Desenvolveu aplicações batch de alto throughput para a Cielo (fintech brasileira) para processar transações de cartão de crédito e gerar cronogramas de pagamento, tratando milhões de registros diariamente com zero perda de dados. Implementou protocolos Spring Security, garantindo conformidade com regulamentações de proteção de dados financeiros.',
      'en': 'Developed high-throughput batch applications for Cielo (Brazilian fintech) to process credit card transactions and generate payment schedules, handling millions of records daily with zero data loss. Implemented Spring Security protocols, ensuring compliance with financial data protection regulations.',
      'it': 'Sviluppato applicazioni batch ad alto throughput per Cielo (fintech brasiliana) per elaborare transazioni con carte di credito e generare cronogrammi di pagamento, gestendo milioni di record giornalieri con zero perdita di dati. Implementato protocolli Spring Security, garantendo conformità con normative di protezione dati finanziari.'
    },
    challenges: {
      'pt-BR': 'Processamento de milhões de transações diárias, conformidade PCI DSS, implementação de segurança financeira com Spring Security, zero perda de dados.',
      'en': 'Processing millions of daily transactions, PCI DSS compliance, financial security implementation with Spring Security, zero data loss.',
      'it': 'Elaborazione di milioni di transazioni giornaliere, conformità PCI DSS, implementazione sicurezza finanziaria con Spring Security, zero perdita dati.'
    },
    lessons: {
      'pt-BR': 'Spring Batch avançado, segurança financeira (PCI DSS), processamento de pagamentos em larga escala, Spring Security.',
      'en': 'Advanced Spring Batch, financial security (PCI DSS), large-scale payment processing, Spring Security.',
      'it': 'Spring Batch avanzato, sicurezza finanziaria (PCI DSS), elaborazione pagamenti su larga scala, Spring Security.'
    },
    technologies: ['Java 8', 'Spring Batch', 'Spring Boot', 'Spring Security', 'JPA/Hibernate', 'EJB', 'Oracle Database', 'Maven', 'SVN'],
    clients: [
      { name: 'Cielo', logo: '/logos/cielo.png' }
    ]
  },
  {
    id: 4,
    company: 'ATOS',
    logo: '/logos/atos.png',
    role: {
      'pt-BR': 'Desenvolvedor Java Senior',
      'en': 'Senior Java Developer',
      'it': 'Sviluppatore Java Senior'
    },
    period: { 'pt-BR': '3 anos', 'en': '3 years', 'it': '3 anni' },
    location: {
      'pt-BR': 'Londrina / São Paulo, Brasil',
      'en': 'Londrina / São Paulo, Brazil',
      'it': 'Londrina / São Paulo, Brasile'
    },
    hasSubProjects: true,
    subProjects: [
      {
        id: 'atos-claro',
        client: {
          'pt-BR': 'Claro - Sistemas de Vendas Telecom',
          'en': 'Claro - Telecom Sales Systems',
          'it': 'Claro - Sistemi Vendite Telecom'
        },
        description: {
          'pt-BR': 'Manutenção e evolução dos sistemas de vendas da Claro (telecomunicações), suportando o lançamento de serviços 4G para milhões de clientes.',
          'en': 'Maintained and enhanced sales systems for Claro (telecom), supporting the rollout of 4G services to millions of customers.',
          'it': 'Manutenzione e evoluzione dei sistemi di vendita di Claro (telecomunicazioni), supportando il lancio di servizi 4G per milioni di clienti.'
        },
        technologies: ['Java', 'Spring MVC', 'Oracle Database', 'REST APIs', 'Jenkins']
      },
      {
        id: 'atos-multiplus',
        client: {
          'pt-BR': 'Multiplus - Integração com Redes Sociais',
          'en': 'Multiplus - Social Network Integration',
          'it': 'Multiplus - Integrazione Social Network'
        },
        description: {
          'pt-BR': 'Desenvolveu integração de pontos de fidelidade com redes sociais (Twitter/Facebook) para a Multiplus, aumentando o engajamento de usuários em 15% através de funcionalidades de troca de pontos em tempo real.',
          'en': 'Developed a loyalty points integration with social networks (Twitter/Facebook) for Multiplus, increasing user engagement by 15% through real-time point exchange features.',
          'it': 'Sviluppato un\'integrazione di punti fedeltà con social network (Twitter/Facebook) per Multiplus, aumentando il coinvolgimento degli utenti del 15% attraverso funzionalità di scambio punti in tempo reale.'
        },
        technologies: ['Java', 'REST APIs', 'Social APIs', 'Spring Boot', 'MySQL']
      }
    ],
    description: {
      'pt-BR': 'Desenvolvimento e manutenção de sistemas para clientes nos setores de telecomunicações e programas de fidelidade, incluindo a Claro e Multiplus.',
      'en': 'Development and maintenance of systems for clients in the telecom and loyalty program sectors, including Claro and Multiplus.',
      'it': 'Sviluppo e manutenzione di sistemi per clienti nei settori telecomunicazioni e programmi fedeltà, inclusi Claro e Multiplus.'
    },
    challenges: {
      'pt-BR': 'Suporte ao lançamento 4G para milhões de clientes, integração em tempo real com redes sociais, APIs de alta disponibilidade.',
      'en': 'Supporting 4G rollout for millions of customers, real-time social network integration, high-availability APIs.',
      'it': 'Supporto al lancio 4G per milioni di clienti, integrazione in tempo reale con social network, API ad alta disponibilità.'
    },
    lessons: {
      'pt-BR': 'Sistemas de telecomunicações em escala, integração com APIs sociais, sistemas de pontos de fidelidade, alta disponibilidade.',
      'en': 'Telecom systems at scale, social API integration, loyalty point systems, high availability.',
      'it': 'Sistemi di telecomunicazioni su scala, integrazione API sociali, sistemi di punti fedeltà, alta disponibilità.'
    },
    technologies: ['Java', 'Spring MVC', 'Spring Boot', 'REST APIs', 'Oracle Database', 'MySQL', 'Maven', 'Git', 'Jenkins'],
    clients: [
      { name: 'Claro', logo: '/logos/claro.png' },
      { name: 'Multiplus', logo: '/logos/multiplus.png' }
    ]
  },
  {
    id: 5,
    company: {
      'pt-BR': 'Carreira Anterior',
      'en': 'Earlier Career',
      'it': 'Carriera Precedente'
    },
    logo: null,
    role: {
      'pt-BR': 'Desenvolvedor e Líder de Equipe',
      'en': 'Developer and Team Leader',
      'it': 'Sviluppatore e Team Leader'
    },
    period: { 'pt-BR': '12 anos', 'en': '12 years', 'it': '12 anni' },
    location: 'Brasil',
    description: {
      'pt-BR': 'Atuou como Desenvolvedor e Líder de Equipe, gerenciando desenvolvimento full-cycle em C++, Delphi e PHP, com foco em arquitetura de banco de dados e implementação de controle de versão.',
      'en': 'Held roles as Developer and Team Leader, managing full-cycle development in C++, Delphi, and PHP, with a focus on database architecture and version control implementation.',
      'it': 'Ruoli come Sviluppatore e Team Leader, gestendo sviluppo full-cycle in C++, Delphi e PHP, con focus su architettura database e implementazione del controllo versione.'
    },
    challenges: {
      'pt-BR': 'Liderança de equipe, gestão de desenvolvimento full-cycle, arquitetura de banco de dados, transição entre múltiplas tecnologias.',
      'en': 'Team leadership, full-cycle development management, database architecture, transitioning between multiple technologies.',
      'it': 'Leadership del team, gestione sviluppo full-cycle, architettura database, transizione tra più tecnologie.'
    },
    lessons: {
      'pt-BR': 'Fundamentos sólidos em múltiplas linguagens, liderança técnica, gestão de ciclo de desenvolvimento completo.',
      'en': 'Solid foundations in multiple languages, technical leadership, full development cycle management.',
      'it': 'Fondamenti solidi in più linguaggi, leadership tecnica, gestione del ciclo di sviluppo completo.'
    },
    technologies: ['C++', 'Delphi', 'PHP', 'Database Architecture', 'SVN']
  }
];

export const skills = {
  languages: [
    { name: 'Java (8, 11, 17, 21)', level: 95, primary: true },
    { name: 'Python', level: 75, primary: true },
    { name: 'JavaScript', level: 70 },
    { name: 'C++', level: 65 },
    { name: 'PHP', level: 55 },
    { name: 'Delphi', level: 50 }
  ],
  databases: [
    { name: 'Oracle', level: 95, primary: true },
    { name: 'PostgreSQL', level: 90, primary: true },
    { name: 'MS SQL Server', level: 85, primary: true },
    { name: 'MySQL', level: 85, primary: true },
    { name: 'MongoDB', level: 75 }
  ],
  frameworks: [
    { name: 'Spring Boot', level: 95, primary: true },
    { name: 'Spring Batch', level: 95, primary: true },
    { name: 'Spring Security', level: 90, primary: true },
    { name: 'Spring Data / MVC', level: 90, primary: true },
    { name: 'Hibernate / JPA', level: 95, primary: true },
    { name: 'REST APIs / Microservices', level: 95, primary: true },
    { name: 'Angular', level: 75 },
    { name: 'JSF / PrimeFaces', level: 85 },
    { name: 'EJB', level: 80 }
  ],
  devops: [
    { name: 'Docker', level: 85, primary: true },
    { name: 'Kubernetes', level: 75, primary: true },
    { name: 'Git', level: 90, primary: true },
    { name: 'Jenkins', level: 85, primary: true },
    { name: 'Apache Maven', level: 90, primary: true },
    { name: 'RabbitMQ / JMS', level: 80 },
    { name: 'JBoss / Tomcat / WebSphere', level: 80 },
    { name: 'SVN', level: 70 }
  ]
};

export const education = {
  'pt-BR': [
    { degree: 'Pós-graduação em Engenharia de Software', institution: 'Universidade Pitágoras Unopar Anhanguera', year: '2024' },
    { degree: 'Especialização em Sistemas Web', institution: 'Universidade Estadual de Maringá (UEM)', year: '2010' },
    { degree: 'Bacharelado em Processamento de Dados', institution: 'ESEEI', year: '2003' }
  ],
  'en': [
    { degree: 'Postgraduate in Software Engineering', institution: 'Universidade Pitágoras Unopar Anhanguera', year: '2024' },
    { degree: 'Specialization in Web Systems', institution: 'State University of Maringá (UEM)', year: '2010' },
    { degree: 'Bachelor\'s in Data Processing', institution: 'ESEEI', year: '2003' }
  ],
  'it': [
    { degree: 'Post-laurea in Ingegneria del Software', institution: 'Universidade Pitágoras Unopar Anhanguera', year: '2024' },
    { degree: 'Specializzazione in Sistemi Web', institution: 'Università Statale di Maringá (UEM)', year: '2010' },
    { degree: 'Laurea in Elaborazione Dati', institution: 'ESEEI', year: '2003' }
  ]
};

export const certifications = {
  'pt-BR': [
    { name: 'Spring Batch', issuer: 'Stefanini', year: '2016' },
    { name: 'Práticas Ágeis em Gestão de Produtos (Product Owner)', issuer: 'Software by Maringá', year: '2011' }
  ],
  'en': [
    { name: 'Spring Batch', issuer: 'Stefanini', year: '2016' },
    { name: 'Agile Practices in Product Management (Product Owner)', issuer: 'Software by Maringá', year: '2011' }
  ],
  'it': [
    { name: 'Spring Batch', issuer: 'Stefanini', year: '2016' },
    { name: 'Pratiche Agili nella Gestione Prodotto (Product Owner)', issuer: 'Software by Maringá', year: '2011' }
  ]
};

export const languages = {
  'pt-BR': [
    { language: 'Português', level: 'Nativo', flag: '🇧🇷' },
    { language: 'Italiano', level: 'B2 - Intermediário Superior', flag: '🇮🇹' },
    { language: 'Inglês', level: 'B1 - Profissional', flag: '🇺🇸' },
    { language: 'Francês', level: 'A2 - Elementar', flag: '🇫🇷' }
  ],
  'en': [
    { language: 'Portuguese', level: 'Native', flag: '🇧🇷' },
    { language: 'Italian', level: 'B2 - Upper Intermediate', flag: '🇮🇹' },
    { language: 'English', level: 'B1 - Professional Working', flag: '🇺🇸' },
    { language: 'French', level: 'A2 - Elementary', flag: '🇫🇷' }
  ],
  'it': [
    { language: 'Portoghese', level: 'Madrelingua', flag: '🇧🇷' },
    { language: 'Italiano', level: 'B2 - Intermedio Superiore', flag: '🇮🇹' },
    { language: 'Inglese', level: 'B1 - Professionale', flag: '🇺🇸' },
    { language: 'Francese', level: 'A2 - Elementare', flag: '🇫🇷' }
  ]
};

export const contactInfo = {
  email: 'contact@belatto.it',
  phone: '+39 366 9818 490',
  linkedin: 'https://linkedin.com/in/joaopaulobelatto',
  location: {
    'pt-BR': 'Pinerolo, Itália',
    'en': 'Pinerolo, Italy',
    'it': 'Pinerolo, Italia'
  }
};
